import Vue from 'vue'

/**
 * The application's core event bus instance.
 *
 * @type {Vue}
 */
export const bus = new Vue()
